import { windowWidth } from "@styles/global";
import styled from "styled-components";

const ResetPasswordFormContainer = styled.div`
  background-color: white;
  padding: 20px 50px;
  width: 100%;
  height: 90%;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  overflow: hidden;
  max-height: 600px;

  @media (max-width: ${windowWidth.mobile.large}) {
    padding: 20 20px !important;
  }

  > form {
    width: 100% !important;
    display: flex;
    flex-direction: column;
    align-items: center;

    > * {
      width: 100%;
    }

    > button {
      margin-top: 20px;
      width: 50%;
      background-color: ${(props) => props.theme.colors.primary};

      :hover {
        background-color: ${(props) => props.theme.colors.secondary};
      }
    }
  }

`;

const ResetPasswordFormLogo = styled.div`
  width: 50%;

  @media (max-height: ${windowWidth.tablet}) and (min-width: ${windowWidth.tablet}) {
    width: 45% !important;
  }

  @media (max-height: 700px) {
    padding-bottom: 20px;
  }
`;

const ResetPasswordInfoContainer = styled.div`
`;

const ResetPasswordDialogContainer = styled.div`

  .MuiPaper-root {
    padding: 25px;

    .dialog {

      &__title {
        text-align: center;
        margin-bottom: 25px;

        img {
          width: 100px;
        }
      }

      &__content {
        text-align: center;
        font-size: 16px;
      }

      &__actions {
        display: flex;
        justify-content: center;

        button {
          margin-top: 20px;
          background-color: ${(props) => props.theme.colors.primary};
        }
      }
    }
  }
`;

export { ResetPasswordFormContainer, ResetPasswordFormLogo, ResetPasswordInfoContainer, ResetPasswordDialogContainer };
